module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pii"
    }
  }), _vm._v("Convening Science: Discovery at the Marine Biological Laboratory")]), _vm._v(" "), _c('p', {
    staticClass: "serau",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("A Series Edited by Jane Maienschein")]), _vm._v(" "), _c('p', {
    staticClass: "serpf"
  }, [_vm._v("I am delighted to serve as editor for the new University of Chicago Press series Convening Science: Discovery at the Marine Biological Laboratory. These books will “highlight the ongoing role the Marine Biological Laboratory plays in the creation and dissemination of science, in its broader historical context, as well as current practice and future potential.” Each volume is anchored at the MBL, including work about the MBL and MBL science and scientists, work by those scientists, work that begins with workshops or research or courses at the MBL, collaborations made possible by the MBL, and so on. Books by, about, with, for, inspired by, and otherwise related to the MBL will capture the spirit of discovery by the community of MBL scientists and students. Some will be monographic, while others are collaborative coherent collections.")]), _vm._v(" "), _c('p', {
    staticClass: "serp"
  }, [_vm._v("We look forward to discovering new ideas and approaches that find their way into volumes of the series. I first did summer research, with a small NSF grant, as a graduate student in 1976, which led to my first edited volume inspired by this special place. Many others have been similarly inspired, and this new series invites us to bring together our works into a collection of reflections on the MBL’s role in promoting discovery through its exceptional role in convening science at the seaside.")]), _vm._v(" "), _c('p', {
    staticClass: "serp",
    staticStyle: {
      "margin-top": "1em",
      "text-indent": "0"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("JANE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MAIENSCHEIN")])]), _vm._v(" "), _c('p', {
    staticClass: "serp",
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("Series Editor")]), _vm._v(" "), _c('p', {
    staticClass: "serp",
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("University Professor of the Center for Biology and Society")]), _vm._v(" "), _c('p', {
    staticClass: "serp",
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("Arizona State University")]), _vm._v(" "), _c('p', {
    staticClass: "serp",
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("Fellow, Marine Biological Laboratory")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4926ac44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-minteer-0003.vue
// module id = 60
// module chunks = 0